/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetAutotaskTicketFields200ResponseStatusesInner
 */
export interface GetAutotaskTicketFields200ResponseStatusesInner {
    /**
     * 
     */
    value: number;
    /**
     * 
     */
    label: string;
    /**
     * 
     */
    isActive: boolean;
}

/**
 * Check if a given object implements the GetAutotaskTicketFields200ResponseStatusesInner interface.
 */
export function instanceOfGetAutotaskTicketFields200ResponseStatusesInner(value: object): value is GetAutotaskTicketFields200ResponseStatusesInner {
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    return true;
}

export function GetAutotaskTicketFields200ResponseStatusesInnerFromJSON(json: any): GetAutotaskTicketFields200ResponseStatusesInner {
    return GetAutotaskTicketFields200ResponseStatusesInnerFromJSONTyped(json, false);
}

export function GetAutotaskTicketFields200ResponseStatusesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAutotaskTicketFields200ResponseStatusesInner {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
        'label': json['label'],
        'isActive': json['isActive'],
    };
}

export function GetAutotaskTicketFields200ResponseStatusesInnerToJSON(json: any): GetAutotaskTicketFields200ResponseStatusesInner {
    return GetAutotaskTicketFields200ResponseStatusesInnerToJSONTyped(json, false);
}

export function GetAutotaskTicketFields200ResponseStatusesInnerToJSONTyped(value?: GetAutotaskTicketFields200ResponseStatusesInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'],
        'label': value['label'],
        'isActive': value['isActive'],
    };
}

